import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Icon from 'components/common/Icon/Icon'
import WarrantyBadge, { WarrantyBadgeTitle } from 'components/common/WarrantyBadge'
import { Column } from '../../../../../Common.styles'
import SpecsTable from '../SpecsTable'

const SpecsTab = ({
  speedRating,
  threadLifeWarranty,
  hidden,
  warrantyBadges: [{
    name: warrantyName,
    value: warrantyValue
  } = {}] = [],
  ...props
}) =>
  <div hidden={ hidden }>
    <Column half centered margin="0 0 40px">
      <WarrantyWrapper>
        <WarrantyBadge name={ warrantyName } warranty={ warrantyValue } />
      </WarrantyWrapper>
      { threadLifeWarranty ?
        <SpecText>{ threadLifeWarranty } mile Tread-Life Warranty</SpecText> :
        <SpecText><WarrantyBadgeTitle name={ warrantyName } value={ warrantyValue } long /></SpecText>
      }
    </Column>
    {
      Boolean(speedRating) &&
        <Column half centered margin="0 0 40px">
          <IconWrapper data-at-sku-speedrating-icon asset="speed-badge" />
          <SpecText data-at-sku-speedrating-text>Up to { speedRating } MPH</SpecText>
        </Column>
    }
    <SpecsTable { ...props } />
  </div>

export default SpecsTab

SpecsTab.propTypes = {
  hidden: PropTypes.bool,
  speedRating: PropTypes.string,
  threadLifeWarranty: PropTypes.string,
  warrantyBadges: PropTypes.arrayOf(PropTypes.shape())
}

const WarrantyWrapper = styled.div`
  margin-bottom: 10px;
`

const IconWrapper = styled(Icon)`
  display: inline-block;
  width: 60px;
  height: 45px;
  margin-bottom: 23px;
  ${Mixin.middle()}
`

const SpecText = styled.div`
  line-height: 22px;
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBold(14)}
`
